import {createSlice} from '@reduxjs/toolkit';
import {isEqual} from 'lodash';
import {RootState} from '../store';

export interface IFiltersSliceState {
  allPeriodsWarning?: boolean
  bankWide?: boolean
  callback?: string
  hier?: string
  label?: string
  period?: string
  periodLabel?: string
  question?: string
  securityType?: string
  stat?: string
  survey?: string
  surveyLabel?: string
  enableDateRangeSelection?: boolean
  periodComparison?: string
  dateRange?: string
  fn?: string
  periodComparisonDateRange?: string
  [key: string]: string | boolean
}

const initialState: IFiltersSliceState = {};

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    updateFilters: (state: IFiltersSliceState, action) => {
      const updatedFilters = action.payload
      if (!isEqual(state, updatedFilters)) {
        state = updatedFilters;
      }
      return state;
    }
  }
});

export const {updateFilters} = filtersSlice.actions;
export const selectFilters = (state: RootState) => state.filters;
export default filtersSlice.reducer;
